import { render, staticRenderFns } from "./FormQuestionMatrixType.vue?vue&type=template&id=0184d5d8"
import script from "./FormQuestionMatrixType.vue?vue&type=script&lang=js"
export * from "./FormQuestionMatrixType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports